import { useState } from 'react';
import api from '../api';

export default function Account() {
  const empresa = localStorage.getItem('nombre_empresa') || 'Mi cuenta';
  const correo  = localStorage.getItem('correo') || '';
  const [form, setForm] = useState({ password_actual: '', password_nueva: '', password_confirmar: '' });
  const [msg, setMsg]   = useState(null);
  const [saving, setSaving] = useState(false);

  const guardar = async () => {
    if (!form.password_actual || !form.password_nueva) { setMsg({ ok: false, txt: 'Completa todos los campos' }); return; }
    if (form.password_nueva !== form.password_confirmar) { setMsg({ ok: false, txt: 'Las contraseñas no coinciden' }); return; }
    if (form.password_nueva.length < 6) { setMsg({ ok: false, txt: 'Mínimo 6 caracteres' }); return; }
    setSaving(true);
    try {
      await api.patch('/config/password', { password_actual: form.password_actual, password_nueva: form.password_nueva });
      setMsg({ ok: true, txt: 'Contraseña actualizada correctamente' });
      setForm({ password_actual: '', password_nueva: '', password_confirmar: '' });
    } catch(e) {
      setMsg({ ok: false, txt: e.response?.data?.detail || 'Error actualizando contraseña' });
    }
    setSaving(false);
  };

  const inp = { width: '100%', padding: '10px 14px', background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 9, color: 'var(--text)', fontSize: 13, outline: 'none', boxSizing: 'border-box' };

  return (
    <div style={{ maxWidth: 560 }}>
      <h1 style={{ fontFamily: 'Inter,sans-serif', fontSize: 22, fontWeight: 700, color: 'var(--text)', marginBottom: 6 }}>Mi cuenta</h1>
      <p style={{ color: 'var(--text-3)', fontSize: 13, marginBottom: 28 }}>Gestiona tu información de acceso</p>
      <div className="ic-card" style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 12, padding: 20, marginBottom: 20 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)', marginBottom: 14 }}>Información de la cuenta</div>
        {[['Empresa', empresa], ['Correo', correo]].map(([k, v]) => (
          <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--surface)' }}>
            <span style={{ fontSize: 12, color: 'var(--text-3)' }}>{k}</span>
            <span style={{ fontSize: 13, color: 'var(--text)', fontWeight: 500 }}>{v}</span>
          </div>
        ))}
      </div>
      <div className="ic-card" style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 12, padding: 20 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)', marginBottom: 6 }}>Cambiar contraseña</div>
        <div style={{ fontSize: 11, color: 'var(--text-3)', marginBottom: 18 }}>Elige una contraseña segura de al menos 6 caracteres.</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {[['password_actual','Contraseña actual'],['password_nueva','Nueva contraseña'],['password_confirmar','Confirmar nueva contraseña']].map(([key, label]) => (
            <div key={key}>
              <label style={{ fontSize: 11, color: 'var(--text-3)', display: 'block', marginBottom: 5 }}>{label}</label>
              <input type="password" value={form[key]} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))} style={inp} />
            </div>
          ))}
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginTop: 4 }}>
            <button onClick={guardar} disabled={saving} style={{ padding: '10px 24px', background: 'linear-gradient(135deg,var(--accent-solid),var(--accent-2))', border: 'none', color: '#fff', borderRadius: 9, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
              {saving ? 'Guardando...' : 'Actualizar contraseña'}
            </button>
            {msg && <span style={{ fontSize: 12, color: msg.ok ? 'var(--success)' : 'var(--danger)', fontWeight: 600 }}>{msg.txt}</span>}
          </div>
        </div>
      </div>
    </div>
  );
}
